module.exports = __webpack_public_path__ + "static/media/stumbleupon.82b0f717.svg";